import React from "react";

import classes from "./styles.module.scss";

const GraphStyleSelector = ({ graphStyle, setGraphStyle }) => {
    return (
        <div className={classes.graphStyleSelectorContainer}>
            <div
                onClick={() => setGraphStyle("stacked")}
                className={`${classes.graphStyleSelectorOption} ${graphStyle === "stacked" ? classes.active : ""}`}
                style={{ borderTopLeftRadius: "4px", borderBottomLeftRadius: "4px", borderRight: "none" }}
            >
                <span>Stacked</span>
            </div>
            <div className={classes.graphStyleSelectorSeparator} />
            <div
                onClick={() => setGraphStyle("clustered")}
                className={`${classes.graphStyleSelectorOption} ${graphStyle === "clustered" ? classes.active : ""}`}
                style={{ borderTopRightRadius: "4px", borderBottomRightRadius: "4px", borderLeft: "none" }}
            >
                <span>Clustered</span>
            </div>
        </div>
    );
};

export default GraphStyleSelector;
